import styled from 'styled-components';

import { BlueLink, Div, OCButton } from 'common/styles/oc-styled-components';
import {
  BREAKPOINTS,
  colors,
  FONT_FAMILIES,
} from 'common/styles/style-constants';

export const StyledContainer = styled(Div)`
  width: 50%;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;
  }
`;

export const SectionDivider = styled.hr`
  border: 1px solid ${colors.nickel};
  margin: 5px 0 30px 0;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin: 20px 0;
  }
`;

export const ExternalLinkListItem = styled.li`
  list-style: none;
  width: 40%;
`;

export const ExternalLink = styled(BlueLink)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 15px 15px;

  svg {
    margin-right: 5px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const ClinicDescription = styled(Div)`
  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.charcoal};
  font-size: 14px;
  white-space: pre-line;
`;

export const ClinicQuestionTitle = styled(Div)`
  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.charcoal};
  font-size: 14px;
  font-weight: 600;
`;

export const ClinicQuestionResponse = styled(Div)`
  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.charcoal};
  font-size: 14px;
  white-space: pre-line;
`;

export const ClinicQuestionDivider = styled(Div)`
  border: 1px solid ${colors.nickel};
  margin: 15px 0 15px 0;
`;

export const ExpandButton = styled(OCButton)`
  && {
    border-radius: 50%;
    height: 32px;
  }

  width: 32px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    && {
      height: 32px;
    }

    width: 32px;
  }
`;
